import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

class ScrollBackgroundGradient {
  constructor(el) {
    this.dom = {el: el};
    // this.dom.target = this.dom.el.querySelectorAll('[data-js="gradient"]');
    // console.log(this.dom.target);
    
    gsap.registerPlugin(ScrollTrigger);

    // this.mql = window.matchMedia('screen and (min-width: 768px)');
    this.checkBreakPoint = this.checkBreakPoint.bind(this);

    this.init();
  }

  init() {
    // [...this.dom.target].forEach(el => {
      gsap.to(this.dom.el, {
        // backgroundImage: 'linear-gradient(to left, rgba(214, 5, 26, .9) 0%, rgba(201, 18, 55, .9) 34.6%, rgba(184, 40, 95, .9) 62.37%, rgba(160, 64, 140, .9) 100%)',
        backgroundPosition: '0% 0%',
        duration: .3,
        scrollTrigger: {
          trigger: this.dom.el,
          start: 'top 50%+=72px',
          end: 'bottom 50%-=72px',
          // toggleActions: 'play none none reverse',
          toggleActions: 'play pause resume reset',
          markers: false,
          id: 'endless',
          once: false,
          // scrub: true,
          scrub: 1 // smoothing
        }
      })
    // })

    // ブレイクポイントの瞬間に発火
    // this.mql.addListener(this.checkBreakPoint);
    // 初回チェック
    // this.checkBreakPoint(this.mql);
  }

  checkBreakPoint(_mql) {
		if (!_mql.matches) {
      // console.log('sp');
      // this.dom.target = this.dom.el.querySelectorAll('[data-js="gradient"]');

      return;
    } else {
      // console.log('pc');
      // this.dom.target = this.dom.el.querySelectorAll('[data-js="gradient"]');

      return;
		}
	}
}

export default ScrollBackgroundGradient